/**
 * Quầy xác nhận "Zalo này đúng là khách này" (0034 — soát bảo mật NẶNG 1, 23/09).
 *
 * Khách dùng Zalo có số trùng hồ sơ tiệm đã nhập tay → máy chủ gắn để không sinh hồ sơ trùng, nhưng
 * CHƯA cho khách xem gói / ví / lịch sử cho tới khi quầy bấm "Đúng người" (số gõ tay có thể nhầm, SIM có
 * thể đã đổi chủ). "Không phải" → gỡ Zalo khỏi hồ sơ; lịch người đó đặt qua Zalo chuyển sang hồ sơ riêng.
 * Chỉ hiện khi có việc — không có ai chờ thì không chiếm chỗ trên màn.
 */

import { formatVnDate, parseIsoStrict } from '@sapa/shared'
import { ChevronDown, ChevronRight, UserCheck } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'
import { type Api, ApiFailure, hienSdt, type ZaloChoXacNhan } from './api.ts'
import { T } from './text/vi.ts'
import { ThongBao } from './ui.tsx'

type Dong = ZaloChoXacNhan

/** "08/10/2026" theo giờ Việt Nam từ ISO của máy chủ; lỗi định dạng → không hiện (không làm hỏng thẻ). */
function ngayLich(iso: string | null | undefined): string | null {
  if (iso === null || iso === undefined) return null
  try {
    return formatVnDate(parseIsoStrict(iso))
  } catch {
    return null
  }
}

export function TheXacNhanZalo({ api }: { api: Api }) {
  const [ds, setDs] = useState<Dong[]>([])
  const [loi, setLoi] = useState<string | null>(null)
  const [dang, setDang] = useState<string | null>(null)
  // Gập thành MỘT dòng: 12 thẻ chen trước ô tìm khách là BLOCKER vòng 39 — người mở dòng này mới thấy thẻ.
  const [mo, setMo] = useState(false)
  const nap = useCallback(() => {
    void api
      .zaloChoXacNhan()
      .then((r) => setDs(r.khach))
      .catch(() => setDs([]))
  }, [api])
  useEffect(nap, [nap])

  async function traLoi(customerId: string, dungNguoi: boolean) {
    setDang(customerId)
    setLoi(null)
    try {
      await api.xacNhanZalo(customerId, dungNguoi)
      nap()
    } catch (e) {
      setLoi(e instanceof ApiFailure ? e.messageVi : T.serverFailed)
    } finally {
      setDang(null)
    }
  }

  if (ds.length === 0) return null
  if (!mo) {
    return (
      <button
        type="button"
        className="dong-mo-xac-nhan"
        aria-expanded={false}
        onClick={() => setMo(true)}
      >
        <UserCheck size={20} />
        <span>{T.zaloCheckOpen(ds.length)}</span>
        <ChevronRight size={20} />
      </button>
    )
  }
  return (
    <section className="the the-dem">
      <h2>
        <button
          type="button"
          className="dong-mo-xac-nhan dong-mo-xac-nhan-tieu-de"
          aria-expanded
          onClick={() => setMo(false)}
        >
          <UserCheck size={20} />
          <span>{T.zaloCheckTitle}</span>
          <ChevronDown size={20} />
        </button>
      </h2>
      <p className="chu-phu">{T.zaloCheckHint}</p>
      {loi !== null && <ThongBao loai="loi">{loi}</ThongBao>}
      <ul className="ds-can-nhac">
        {ds.map((k) => (
          <li key={k.customerId}>
            <div className="dong-can-nhac-dau">
              <b>{k.ten}</b>
              {k.phone !== null && <span className="chu-phu">{hienSdt(k.phone)}</span>}
            </div>
            {k.tuGop === true && <p className="chu-phu">{T.zaloCheckFromMerge}</p>}
            {k.soLichQuaZalo !== undefined && k.soLichQuaZalo > 0 && (
              <p className="chu-phu">
                {T.zaloCheckSignal(k.soLichQuaZalo, ngayLich(k.lichQuaZaloLuc))}
              </p>
            )}
            {k.duocXacNhan === false && <p className="chu-phu">{T.zaloCheckOwnerOnly}</p>}
            <div className="hang-phu">
              {k.duocXacNhan !== false && (
                <button
                  type="button"
                  className="nut nut-chinh"
                  disabled={dang === k.customerId}
                  onClick={() => void traLoi(k.customerId, true)}
                >
                  {T.zaloRight}
                </button>
              )}
              <button
                type="button"
                className="nut nut-vien"
                disabled={dang === k.customerId}
                onClick={() => void traLoi(k.customerId, false)}
              >
                {T.zaloWrong}
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
